import { g as gsapWithCSS } from "@theme/theme";
class ProductCardComponent extends window.HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }
  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    gsapWithCSS.matchMedia().add("(hover: none)", () => {
      this.addEventListener("click", this.handleClick);
      document.addEventListener("click", this.handleDocumentClick);
      return () => {
        this.removeEventListener("click", this.handleClick);
        document.removeEventListener("click", this.handleDocumentClick);
        this.classList.remove("is-active");
      };
    });
  }
  handleClick(e) {
    e.stopPropagation();
    if (!this.classList.contains("is-active")) {
      e.preventDefault();
      document.querySelectorAll("c-product-card.is-active").forEach((card) => {
        if (card !== this) card.classList.remove("is-active");
      });
      this.classList.add("is-active");
    }
  }
  handleDocumentClick() {
    document.querySelectorAll("c-product-card.is-active").forEach((card) => {
      card.classList.remove("is-active");
    });
  }
}
window.customElements.define("c-product-card", ProductCardComponent);
